import { dateFormat } from "../../../utils/utils";
import { DocumentStatusEnum } from "../models/DocumentStatusEnums";
import i18next from "i18next";

export const generateItems = (data: any) => {
    const items: any[] = [];

    data.forEach((data: any) => {
        items.push({
            id: data.id,
            key: data.key,
            description: data.description,
            documentDate: dateFormat(data.documentDate, "DD.MM.YYYY"),
            documentTypeName: data.documentTypeName,
            documentType: data.documentType,
            companyName: data.companyName,
            receptionPlaceName: data.receptionPlaceName,
            containersNumber: data.containersNumber,
            documentStatusStr: getDocumentStatusText(data.documentStatus),
            documentStatus: data.documentStatus,
            internalStoreName: data.internalStoreName,
            fileExists: data.fileExists,
            blobFileName: data.blobFileName
        });
    });

    items.sort((a, b) => {
        return new Date(b.documentDate).getTime() - new Date(a.documentDate).getTime();
    });

    return [...items];
};

const getDocumentStatusText = (status: number): string => {
    const t = i18next.getFixedT(null, "admin");
    const statusMap: Record<number, string> = {
        [DocumentStatusEnum.BUFFOR]: "storeDocs.status.buffer",
        [DocumentStatusEnum.APPROVED]: "storeDocs.status.approved",
        [DocumentStatusEnum.CANCELED]: "storeDocs.status.canceled",
        [DocumentStatusEnum.CORRECTION]: "storeDocs.status.correction",
    };

    const key = statusMap[status];
    return key ? t(key) : "";
};